module.exports = __webpack_public_path__ + "static/media/undraw_coding.1aff01a9.svg";